<template>
  <div class="container pb-20 pt-60 md:pt-80">
    <!-- Intro -->
    <div class="content-start">
      <div class="max-w-screen-lg">
        <h1 class="my-10 text-header1 md:text-desktop-header1">
          {{ page?.data.title }}
        </h1>
        <h2 class="mb-10 text-header2 md:text-desktop-header2">
          {{ page?.data.sub_title }}
        </h2>
        <PrismicRichText
          :field="page?.data.description"
          class="text-large-copy md:text-desktop-large-copy"
        />
      </div>

      <!-- Slices -->
      <SliceZone
        wrapper="main"
        :slices="page?.data.slices ?? []"
        :components="components"
        class="my-20"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { components } from "~/slices";

gsap.registerPlugin(ScrollToPlugin);

const prismic = usePrismic();
const route = useRoute();
const config = useRuntimeConfig();

const { data: page } = await useAsyncData(route.params.uid as string, async () =>
  prismic.client.getByUID("pages", route.params.uid as string),
);

if (!page.value) {
  throw createError({ statusCode: 404 });
}

onMounted(() => {
  nextTick(() => {
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        gsap.to(window, { duration: 1, scrollTo: { y: element, offsetY: 100 } });
      }
    }
  });
});

useSeoMeta({
  description: () => page.value?.data.meta_description?.length ? page.value.data.meta_description : prismic.asText(page.value?.data.description),
  ogTitle: () => page.value?.data.meta_title?.length ? page.value.data.meta_title : page.value?.data.title,
  ogUrl: () => `${config.public.BASE_URL}${route.fullPath}`,
  ogDescription: () => page.value?.data.meta_description?.length ? page.value.data.meta_description : prismic.asText(page.value?.data.description),
  ogImage: () => page.value?.data.meta_image.url?.length ? page.value.data.meta_image.url : `${config.public.BASE_URL}/lightbox_gallery.jpg`,
  ogImageType: () => "image/jpeg",
  ogImageWidth: () => "1200",
  ogImageHeight: () => "630",
  ogType: () => "website",
  twitterTitle: () => page.value?.data.meta_title?.length ? page.value.data.meta_title : page.value?.data.title,
  twitterImage: () => page.value?.data.meta_image.url?.length ? page.value.data.meta_image.url : `${config.public.BASE_URL}/lightbox_gallery.jpg`,
  twitterDescription: () => page.value?.data.meta_description?.length ? page.value.data.meta_description : prismic.asText(page.value?.data.description),
});
</script>
